import { ArrowRight } from 'lucide-react';
import { useMemo } from 'react';
import { Link } from 'react-router';

import { PRODUCTS } from '@/data/products';
import { EMPTY_FILTERS } from '@/features/catalog/catalog.types';
import { filterProducts } from '@/features/catalog/filterProducts';

import { Section, SectionHeading } from '../common/Section';
import { ProductGrid } from '../commerce/ProductGrid';
import { Button } from '../ui/button';

/** Top of the relevance ranking — the products that carry the store. */
export function FeaturedProducts() {
  const featured = useMemo(
    () => filterProducts(PRODUCTS, { ...EMPTY_FILTERS, onlyInStock: true }).slice(0, 8),
    [],
  );

  return (
    <Section tone="white" size="md">
      <SectionHeading
        eyebrow="Os queridinhos"
        title="Mais pedidos da BrucePets"
        description="O que sai da nossa distribuidora todo dia — testado e aprovado por milhares de pets."
        className="mb-10"
      />

      <ProductGrid products={featured} priorityCount={4} />

      <div className="mt-10 flex justify-center">
        <Button asChild variant="outline" size="lg">
          <Link to="/catalogo">
            Ver catálogo completo
            <ArrowRight aria-hidden="true" />
          </Link>
        </Button>
      </div>
    </Section>
  );
}
